<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 10H17.5H2.5Z" fill="#374151"/>
    <path d="M8.33333 15.8333L2.5 10M2.5 10L8.33333 4.16666M2.5 10H17.5" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>